import type { Subscription } from '~/interfaces/subscriptions';

const INVALID_SUBSCRIPTION_STATUSES = ['validating', 'invalid'];

/**
 * A subscription is "invalid" while its status is being validated or has been
 * rejected — in these states subscriber-facing profile/account actions are hidden.
 */
export const isInvalidSubscription = (subscription?: Subscription | null): boolean =>
  INVALID_SUBSCRIPTION_STATUSES.includes(subscription?.status ?? '');
